<!-- classess / modal edit -->
<template>
  <b-modal :id="'edit-clase'" size="lg"  title="Editar Clase" @show="updateItem()">
    <div v-if="isLoading">Cargando..</div>
    <div v-if="!isLoading">
      <!-- group 1 -->
      <b-row class="mt-1">
        <b-col>
          <h6>Datos principales</h6>
          <hr class="mt-0">
        </b-col>
      </b-row>
      <b-row id="setings" class="container">
        <b-col>
          <b-form-group
              id="yearOptions"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="9"
              label="Año"
              label-for="yearOptions"
            >
            <b-form-select v-model="formClass.x_year_id" :options="yearOptions"></b-form-select>
          </b-form-group>
          <b-form-group
              id="courseOptions"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="9"
              label="Curso"
              label-for="courseOptions"
            >
            <b-form-select v-model="formClass.x_product_template_id" :options="courseOptions"></b-form-select>
          </b-form-group>
          <b-form-group
              id="roomOptions"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="9"
              label="Aula"
              label-for="roomOptions"
            >
            <b-form-select v-model="formClass.x_room_id" :options="roomOptions"></b-form-select>
          </b-form-group>
         
           <b-form-group
              id="teacherOptions"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="9"
              label="Docente"
              label-for="teacherOptions"
            >
            <b-form-select v-model="formClass.x_teacher_id" :options="teacherOptions"></b-form-select>
          </b-form-group>
           <b-form-group
              id="x_comment"
              label-cols-sm="4"
              label-cols-lg="3"
              content-cols-sm
              content-cols-lg="9"
              label="Comentario"
              label-for="x_comment"
            >
                <b-form-textarea v-model="formClass.x_comment" placeholder="Ingrese un comentario para esta clase" rows="3"></b-form-textarea>
            </b-form-group>
        </b-col>
      </b-row>
      <!-- group 2 -->
      <b-row class="mt-2">
        <b-col>
          <h6>Horarios</h6>
          <hr class="mt-0">
        </b-col>
      </b-row>
      <b-row class="container mb-3" v-for="(v, k) in formClass.schedule" :key="k" align-v="end">
        <b-col>
          <label for="">Día</label>
          <b-form-select v-model="formClass.schedule[k].x_day_of_week" :options="dayOptions"></b-form-select>
        </b-col>
        <b-col>
          <label for="">Aula</label>
          <b-form-select v-model="formClass.schedule[k].x_room_id" :options="roomOptions"></b-form-select>
        </b-col>
        <b-col>
          <label for="">Desde</label>
          <b-input v-model="formClass.schedule[k].x_start_time"></b-input>
        </b-col>
        <b-col>
          <label for="">Hasta</label>
          <b-input v-model="formClass.schedule[k].x_end_time"></b-input>
        </b-col>
        <b-col cols="1">
          <b-button @click="quitarHorario(k)" variant="outline-danger" ><b-icon icon="trash-fill"  aria-hidden="true"></b-icon></b-button>
        </b-col>
      </b-row>
    <b-row>
      <b-col>
        <b-button @click="agregarHorario()" class="mt-1" variant="light" block><b-icon icon="plus"></b-icon>Agregar</b-button>
      </b-col>
    </b-row>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button @click="cancel" variant="link">
        Cancelar
      </b-button>
      <b-button @click="guardarClase()" variant="primary">
        Guardar
      </b-button>
    </template>
    
  </b-modal>
  
</template>

<script>
import { ScheduleService } from '@/services/schedule.service'
import { ClassesService } from '@/services/classes.service'
import { RoomService } from '@/services/room.service'
import { CoursesService } from '@/services/courses.service'
import { TeacherService } from '@/services/teacher.service'

// import { EnrollmentsService } from '@/services/enrollments.service'

export default {
  name: 'view-class-enrollments',
  props: [],
  data () {
    return {
      isLoading: false,
      years: this.$store.state.year.list,
      classes: [],
      courses: [],
      item: {},
      rooms: [],
      teachers: [],
      formClass: {
        x_year_id: 13,
        x_product_template_id: 1,
        x_room_id: 1,
        x_teacher_id: 3,
        schedule: [
          { x_room_id: 1, x_day_of_week: 'monday', x_start_time: '07:00', x_end_time: '08:00' }
        ]
      }
    }
  },
  watch: {
    item: async function (newVal, oldVal) {
      const scheduleClass = await ScheduleService.list({ x_class_id: this.item.id })
      this.formClass = {
        id: this.item.id,
        x_year_id: this.item.x_year_id[0],
        x_product_template_id: this.item.x_product_template_id[0],
        x_room_id: this.item.x_room_id[0],
        x_teacher_id: this.item.x_teacher_id[0],
        x_comment: this.item.x_comment,
        schedule: []
      }
      const schedule = []
      for (var i = 0; i < scheduleClass.length; i++) {
        schedule.push({
          id: scheduleClass[i].id,
          x_room_id: scheduleClass[i].x_room_id[0],
          x_day_of_week: scheduleClass[i].x_day_of_week,
          x_start_time: scheduleClass[i].x_start_time,
          x_end_time: scheduleClass[i].x_end_time
        })
      }
      this.formClass.schedule = schedule
      console.log(this.formClass)
    }
  },
  computed: {
    yearOptions () {
      const opts = []
      for (var i = 0; i < this.years.length; i++) {
        opts.push({ value: this.years[i].id, text: this.years[i].x_year })
      }
      return opts
    },
    courseOptions () {
      const opts = []
      for (var i = 0; i < this.courses.length; i++) {
        opts.push({ value: this.courses[i].id, text: this.courses[i].name })
      }
      return opts
    },
    courseObject () {
      const opts = {}
      for (var i = 0; i < this.courses.length; i++) {
        opts[this.courses[i].id] = this.courses[i]
      }
      return opts
    },
    roomOptions () {
      const opts = []
      for (var i = 0; i < this.rooms.length; i++) {
        opts.push({ value: this.rooms[i].id, text: this.rooms[i].x_name })
      }
      return opts
    },
    roomObject () {
      const opts = {}
      for (var i = 0; i < this.rooms.length; i++) {
        opts[this.rooms[i].id] = this.rooms[i]
      }
      return opts
    },
    teacherOptions () {
      const opts = []
      for (var i = 0; i < this.teachers.length; i++) {
        opts.push({ value: this.teachers[i].id, text: this.teachers[i].x_name })
      }
      return opts
    },
    dayOptions () {
      return [
        { value: 'monday', text: 'Lunes' },
        { value: 'tuesday', text: 'Martes' },
        { value: 'wednesday', text: 'Miercoles' },
        { value: 'thursday', text: 'Jueves' },
        { value: 'friday', text: 'Viernes' }
      ]
    },
    dayObject () {
      return {
        monday: 'Lun',
        tuesday: 'Mar',
        wednesday: 'Mie',
        thursday: 'Jue',
        friday: 'Vie'
      }
    }
  },
  async created () {
    this.years = this.$store.state.year.list
    this.year = this.$store.state.year.selected
    this.rooms = await RoomService.list()
    this.teachers = await TeacherService.list()
    this.courses = await CoursesService.list()

    // this.verInscriptosList = await EnrollmentsService.read(this.enrollments_ids, [])
  },
  methods: {
    updateItem () {
      this.item = this.$session.get('editClassItem')
      console.log(this.item)
    },
    async guardarClase () {
      this.isLoading = true
      console.log(this.formClass)
      const course = this.courseObject[this.formClass.x_product_template_id]
      let name = course.x_short_name + ' '
      let time = this.formClass.schedule[0].x_start_time + '-' + this.formClass.schedule[0].x_end_time
      let days = ''
      for (var i = 0; i < this.formClass.schedule.length; i++) {
        const scheduleItem = this.formClass.schedule[i]
        const scheduleTime = this.formClass.schedule[i].x_start_time + '-' + this.formClass.schedule[i].x_end_time
        if (time !== scheduleTime) {
          name += days + ' ' + time + ' '
          time = scheduleTime
          days = ''
        }
        if (days !== '') {
          days += ','
        }
        days += this.dayObject[scheduleItem.x_day_of_week]
      }
      name += days + ' ' + time
      const classe = {
        x_name: name,
        x_comment: this.formClass.x_comment,
        x_product_template_id: this.formClass.x_product_template_id,
        x_room_id: this.formClass.x_room_id,
        x_teacher_id: this.formClass.x_teacher_id,
        x_year_id: this.formClass.x_year_id
      }
      await ClassesService.update([this.formClass.id], classe)
      for (let i = 0; i < this.formClass.schedule.length; i++) {
        console.log(this.formClass.schedule[i])
        await ScheduleService.update([this.formClass.schedule[i].id], this.formClass.schedule[i])
      }
      
      this.$emit('updateClases')
      this.$bvModal.hide('edit-clase')
      this.isLoading = false
    },
    quitarHorario (index) {
      this.formClass.schedule.splice(index, 1)
    },
    agregarHorario () {
      this.formClass.schedule.push({ x_room_id: '', x_day_of_week: '', x_start_time: '', x_end_time: '' })
    }
  }
}
</script>

<style lang='scss' scoped>
label {
  margin-bottom: 0.1rem;
}
</style>
